import React, { useState, useEffect } from "react";
import WebRoutes from "./Routes/WebRoutes";
import { useDispatch } from "react-redux";
import { userActions } from "./_actions";
import { getCookie } from "./_helpers/cookie";

export default function App() {
  const dispatch = useDispatch();
  const [urlParamsProcessed, setUrlParamsProcessed] = useState(false);
  const [authToken, setAuthToken] = useState(() => {
    return getCookie('authToken') || localStorage.getItem('userToken') || null;
  });

  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get('token');
  const urlUserId = urlParams.get('userId');
  const urlEmail = urlParams.get('email');
  


  // Process URL parameters first
  useEffect(() => {
    if (urlToken && urlUserId && urlEmail && !urlParamsProcessed) {
      console.log('Setting authentication data from URL parameters');
      localStorage.setItem('userToken', urlToken);
      localStorage.setItem('id', urlUserId);
      localStorage.setItem('email', urlEmail);
      localStorage.setItem('is_login', 'true');
      setAuthToken(urlToken);
      // Clean the URL by removing the parameters
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);
      setUrlParamsProcessed(true);
    }
  }, [urlToken, urlUserId, urlEmail, urlParamsProcessed, dispatch]);
  const [isValidating, setIsValidating] = useState(true);
  useEffect(() => {
    console.log('authToken', authToken);
    const validateSession = async () => {
      if (!authToken) {
        setIsValidating(false);
        return;
      }
      try 
      {
        const result = await dispatch(userActions.userSession({ token: authToken }));

        console.log('validateSession result', result);
        
        if (!result?.sucess && !result?.success) {
          // Clear all data if session is invalid
          localStorage.removeItem("id");
          localStorage.removeItem("email");
          localStorage.removeItem("is_login");
          localStorage.removeItem("user_pro");
          localStorage.removeItem("userToken");
          document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 UTC; secure; SameSite=None`;
        }
      } catch (error) {
        // Clear all data on error
        localStorage.removeItem("id");
        localStorage.removeItem("email");
        localStorage.removeItem("is_login");
        localStorage.removeItem("user_pro");
        localStorage.removeItem("userToken");
        document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 UTC; secure; SameSite=None`;
      } finally {
        setIsValidating(false);
      }
    };

    validateSession();
  }, [authToken, dispatch]);

  if (isValidating) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  return <WebRoutes />;
}
